<template>
	<v-layout align-center justify-center wrap v-if="bidder">
		<v-flex xs12>
			<v-text-field
				data-vv-name="polishName"
				data-vv-as="Polska nazwa podmiotu"
				:error-messages="vErrors.collect('polishName')"
				label="Polska nazwa podmiotu *"
				aria-label="Polish name"
				for="polish-name"
				id="polish-name"
				v-model="bidder.polishName"
				v-validate="'required'"
			></v-text-field>
		</v-flex>
		<v-flex xs12>
			<v-text-field
				data-vv-name="englishName"
				data-vv-as="Angielska nazwa podmiotu"
				:error-messages="vErrors.collect('englishName')"
				label="Angielska nazwa podmiotu *"
				aria-label="English name"
				for="english-name"
				id="english-name"
				v-model="bidder.englishName"
				v-validate="'required'"
			></v-text-field>
		</v-flex>
		<v-flex xs12>
			<v-text-field
				browser-autocomplete="off"
				data-vv-name="street"
				data-vv-as="Ulica"
				:error-messages="vErrors.collect('street')"
				label="Ulica *"
				aria-label="Street"
				for="street"
				id="street"
				v-model="bidder.street"
				v-validate="'required'"
			></v-text-field>
		</v-flex>
		<v-flex xs12>
			<v-text-field
				browser-autocomplete="off"
				data-vv-name="building"
				data-vv-as="Numer domu"
				:error-messages="vErrors.collect('building')"
				label="Numer domu *"
				aria-label="Building"
				for="building"
				id="building"
				v-model="bidder.building"
				v-validate="'required'"
			></v-text-field>
		</v-flex>
		<v-flex xs12>
			<v-text-field
				browser-autocomplete="off"
				label="Numer lokalu"
				aria-label="Apartment"
				for="apartment"
				id="apartment"
				v-model="bidder.apartment"
			></v-text-field>
		</v-flex>
		<v-flex xs12>
			<v-text-field
				browser-autocomplete="off"
				data-vv-name="postalCode"
				data-vv-as="Kod pocztowy"
				:error-messages="vErrors.collect('postalCode')"
				label="Kod pocztowy *"
				aria-label="Postal code"
				for="postal-code"
				id="postal-code"
				v-model="bidder.postalCode"
				data-vv-validate-on="none"
				v-validate="{ required: true, regex: /^([0-9]{2}-[0-9]{3})$/}"
				return-masked-value
				:mask="'##-###'"
			></v-text-field>
		</v-flex>
		<v-flex xs12>
			<v-text-field
				browser-autocomplete="off"
				data-vv-name="city"
				data-vv-as="Miejscowość"
				:error-messages="vErrors.collect('city')"
				label="Miejscowość *"
				aria-label="City"
				for="city"
				id="city"
				v-model="bidder.city"
				v-validate="'required'"
			></v-text-field>
		</v-flex>
		<v-flex xs12>
			<v-select
				browser-autocomplete="off"
				data-vv-name="province"
				data-vv-as="Województwo"
				:error-messages="vErrors.collect('province')"
				v-model="bidder.province"
				:items="provinceItems"
				label="Województwo *"
				aria-label="Province"
				for="province"
				id="province"
				v-validate="'required'"
			></v-select>
		</v-flex>
	</v-layout>
</template>

<script>
export default {
  name: "SystemFixBidderFormView",

  provide() {
    return {parentValidator: this.$validator};
  },

  data() {
    return {
      bidder: null,
      provinceItems: [
        "dolnośląskie",
        "kujawsko-pomorskie",
        "lubelskie",
        "lubuskie",
        "łódzkie",
        "małopolskie",
        "mazowieckie",
        "opolskie",
        "podkarpackie",
        "podlaskie",
        "pomorskie",
        "śląskie",
        "świętokrzyskie",
        "wamińsko-mazurskie",
        "wielkopolskie",
        "zachodniopomorskie",
      ],
    };
  },

  watch: {
    selectedBidderData: {
      handler(value) {
        if (value) {
          this.bidder = value;
        }
      },
      immediate: true
    }
  },

  props: {
    selectedBidderData: {type: Object, required: true}
  }
};
</script>

<style scoped>

</style>